// packages/ui/src/components/HelperTextWithLength.tsx
'use client';

import { Box } from '@mui/material';
import type { ReactNode } from 'react';

/**
 * A text field's helper text with the text's length counter on the right — `312/300`, red when the
 * text is over its limit. The one rendering of a character counter: `FormTextField`'s `maxLength`
 * and the language-tab editors that mark a text over its limit (docs/content-translation.md §2.13.7
 * "As built (R5 review)") all use it. Pass it as a `TextField`'s `helperText`.
 */
export function HelperTextWithLength({ helper, length, max }: { helper?: ReactNode; length: number; max: number }) {
  const overLimit = length > max;
  return (
    <Box component="span" sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
      <Box component="span">{helper}</Box>
      <Box
        component="span"
        sx={{
          flexShrink: 0,
          color: overLimit ? 'error.main' : 'text.secondary',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {length}/{max}
      </Box>
    </Box>
  );
}
